var map = {
	"./1001-关于新冠的误解.md": 3609,
	"./1002-2021元旦祝福.md": 5895,
	"./1003-无职转生评价.md": 7400,
	"./1004-进击的巨人完结感想.md": 844,
	"./1005-命运石之门观后感.md": 4316,
	"./1006-2022元旦感悟.md": 3068,
	"./1007-86不存在的战区动画点评.md": 5409,
	"./1008-人类早期接触网页开发的日记.md": 3085,
	"./1009-青猪12卷关于未来剧情预测.md": 2597,
	"./1010-2023元旦感悟.md": 5622,
	"./1011-铃芽之旅影评.md": 7416,
	"./1012-大学申请.md": 6185,
	"./1013-2024元旦感悟.md": 7336,
	"./1014-uoft排课系统心得.md": 3858,
	"./1016-关于python的super函数.md": 9959,
	"./1017-如何搭建VPN.md": 5101,
	"./1018-晚安酸欠少女さユり.md": 3422,
	"./1019-个人网站项目心得.md": 4926,
	"./1020-2025元旦感悟.md": 6721,
	"./1021-青猪完结评价.md": 192,
	"./1022-2026元旦感悟.md": 2714,
	"./blogImg/1003/无职转生全家福.jpg": 804,
	"./blogImg/1003/无职转生全家福_真.jpg": 2802,
	"./blogImg/1008/day11.gif": 7840,
	"./blogImg/1008/day14.gif": 2669,
	"./blogImg/1008/day15.gif": 6388,
	"./blogImg/1008/day18_airdrop1.jpg": 5919,
	"./blogImg/1008/day18_airdrop2.jpg": 2304,
	"./blogImg/1008/day5.gif": 107,
	"./blogImg/1012/alberta.png": 5173,
	"./blogImg/1012/mcgill.png": 4336,
	"./blogImg/1012/mcmaster.png": 718,
	"./blogImg/1012/queen.png": 8752,
	"./blogImg/1012/sfu.png": 3066,
	"./blogImg/1012/ubc.png": 4438,
	"./blogImg/1012/utm.png": 8346,
	"./blogImg/1012/utsc.png": 8885,
	"./blogImg/1012/utsg.png": 9249,
	"./blogImg/1012/waterloo.png": 4181,
	"./blogImg/1012/western.png": 148,
	"./blogImg/1014/v1主页.jpg": 4873,
	"./blogImg/1014/v1选表页.jpg": 5801,
	"./blogImg/1014/v2查看路程与时间.jpg": 7510,
	"./blogImg/1014/v2移动端适配.jpg": 1707,
	"./blogImg/1014/v2选时间段.jpg": 1102,
	"./blogImg/1017/windoes_v2rayN_1.png": 8997,
	"./blogImg/1017/windoes_v2rayN_2.png": 846,
	"./blogImg/1018/酸欠少女.png": 6510,
	"./blogImg/1019/项目开始.jpg": 7583,
	"./blogImg/1019/鸽了两个月的pyq.jpg": 1638,
	"./blogImg/86不存在的战区完结.jpg": 7145,
	"./blogImg/newYear/2021元旦锁屏截图.jpg": 5987,
	"./blogImg/newYear/2022元旦锁屏截图.jpg": 8644,
	"./blogImg/newYear/2023元旦锁屏截图.jpg": 3113,
	"./blogImg/newYear/2024元旦锁屏截图.jpg": 9850,
	"./blogImg/newYear/2025元旦锁屏截图.png": 1967,
	"./blogImg/newYear/2026元旦锁屏截图.png": 6532,
	"./blogImg/进击的巨人138p46.jpg": 8967,
	"./blogImg/铃芽之旅海报.jpg": 2957,
	"./blogImg/青猪第12卷封面.jpg": 8380,
	"./blogImg/青猪第15卷封面.jpg": 3361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8245;